import {
  GAME_COUNTRY,
  GAME_NEIGHBOURS,
  GAME_CAPITAL,
  GAME_FLAGS,
  GAME_SPOKEN_LANGUAGE,
  GAME_POPULATION,
  GAME_CURRENCY,
  GAME_POPULOUS_CITIES,
  GAME_AREA,
} from "./gameTypes";

const gameImages = {
  yesOrNo: [
    {
      imgSrc: "/images/274c.png",
      imgAlt: "❌",
    },
    {
      imgSrc: "/images/2705.png",
      imgAlt: "✅",
    },
  ],
  yellowGreen: [
    {
      imgSrc: "/images/2b1b.png",
      imgAlt: "⬛",
    },
    {
      imgSrc: "/images/1f7e8.png",
      imgAlt: "🟨",
    },
    {
      imgSrc: "/images/1f7e9.png",
      imgAlt: "🟩",
    },
  ],
  journeySvgs: [
    {
      imgSrc: "/images/progress/plane.svg",
      imgAlt: "🟩",
    },
    {
      imgSrc: "/images/progress/train.svg",
      imgAlt: "🟩",
    },
    {
      imgSrc: "/images/progress/car.svg",
      imgAlt: "🟩",
    },
    {
      imgSrc: "/images/progress/run.svg",
      imgAlt: "🟩",
    },
    {
      imgSrc: "/images/progress/walk.svg",
      imgAlt: "🟩",
    },
  ],
  directions: [
    {
      imgSrc: "/images/1f389.png",
      imgAlt: "🎉",
    },
    {
      imgSrc: "/images/2b06.png",
      imgAlt: "⬆️",
    },
    {
      imgSrc: "/images/2197.png",
      imgAlt: "↗️",
    },
    {
      imgSrc: "/images/27a1.png",
      imgAlt: "➡️",
    },
    {
      imgSrc: "/images/2198.png",
      imgAlt: "↘️",
    },
    {
      imgSrc: "/images/2b07.png",
      imgAlt: "⬇️",
    },
    {
      imgSrc: "/images/2199.png",
      imgAlt: "↙️",
    },
    {
      imgSrc: "/images/2b05.png",
      imgAlt: "⬅️",
    },
    {
      imgSrc: "/images/2196.png",
      imgAlt: "↖️",
    },
  ],
  categories: [
    {
      key: GAME_COUNTRY,
      label: "Country",
      imgSrcs: ["/images/1f389.png"],
      imgAlts: ["🎉"],
    },
    {
      key: GAME_NEIGHBOURS,
      label: "Neighbours",
      imgSrcs: ["/images/1f9ed.png"],
      imgAlts: ["🧭"],
    },
    {
      key: GAME_CAPITAL,
      label: "Capital",
      imgSrcs: ["/images/2b50.png"],
      imgAlts: ["⭐"],
    },
    {
      key: GAME_FLAGS,
      label: "Flag",
      imgSrcs: ["/images/1f6a9.png"],
      imgAlts: ["🚩"],
    },
    {
      key: GAME_SPOKEN_LANGUAGE,
      label: "Spoken languages",
      imgSrcs: ["/images/1f524.png", "/images/1f5e3.png"],
      imgAlts: ["🔤", "🗣️"],
    },
    {
      key: GAME_POPULATION,
      label: "Population",
      imgSrcs: ["/images/1f46b.png"],
      imgAlts: ["👫"],
    },
    {
      key: GAME_CURRENCY,
      label: "Currency",
      imgSrcs: ["/images/1fa99.png"],
      imgAlts: ["🪙"],
    },
    {
      key: GAME_POPULOUS_CITIES,
      label: "Populous cities",
      imgSrcs: ["/images/1f3d9.png"],
      imgAlts: ["🏙"],
    },
    {
      key: GAME_AREA,
      label: "Area",
      imgSrcs: ["/images/1f4d0.png"],
      imgAlts: ["📐"],
    },
  ],
};

export default gameImages;
